import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

@doc.path('/plan_analyses/{id}/detections')
export default class PlanAnalysisDetectionsModel extends MapServiceModel {
}
